<template>
  <DxPopup
    :visible="loadingVisible"
    title="Loading data..."
    :drag-enabled="false"
    :hide-on-outside-click="false"
    width="300"
    :height="130"
  >
    <div class="d-flex justify-content-center">
      <div
        class="spinner-border"
        style="width: 3rem; height: 3rem"
        role="status"
      ></div>
    </div>
  </DxPopup>

  <header class="header-component">
    <dx-toolbar class="header-toolbar">
      <dx-item
        :visible="menuToggleEnabled"
        location="before"
        css-class="menu-button"
      >
        <template #default>
          <dx-button icon="menu" styling-mode="text" @click="toggleMenuFunc" />
        </template>
      </dx-item>

      <dx-item
        v-if="title"
        location="before"
        css-class="header-title dx-toolbar-label"
      >
        <div>{{ title }}</div>
      </dx-item>

      <dx-item
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
      >
        <template #default>
          <div>
            <dx-button
              class="user-button authorization"
              :width="210"
              height="100%"
              styling-mode="text"
            >
              <!-- <user-panel
                :email="email"
                :menu-items="userMenuItems"
                menu-mode="context"
              /> -->
              <user-panel
                :email="name"
                :menu-items="userMenuItems"
                menu-mode="context"
              />
            </dx-button>
          </div>
        </template>
      </dx-item>

      <template #menuUserItem>
        <!-- <user-panel
          :email="email"
          :menu-items="userMenuItems"
          menu-mode="list"
        /> -->
        <user-panel
          :email="name"
          :menu-items="userMenuItems"
          menu-mode="list"
        />
      </template>
    </dx-toolbar>
  </header>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import auth from "../auth";
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import { useCommonStore } from "@/stores/utility/common-store2";
import { useAppStore } from "@/stores/UseAppStore";

import UserPanel from "./user-panel";

export default {
  props: {
    menuToggleEnabled: Boolean,
    title: String,
    toggleMenuFunc: Function,
    logOutFunc: Function,
  },
  setup() {
    const appStore = useAppStore();
    const router = useRouter();
    const route = useRoute();

    const email = ref("");
    email.value = auth.getUser().email;

    const name = ref("");
    name.value = auth.getUser().name;
    // auth.getUser().then((e) => (email.value = e.data.email));
    let loadingVisible = ref(false);
    const userMenuItems = [
      // {
      //   text: "Profile",
      //   icon: "user",
      //   onClick: onProfileClick,
      // },

      {
        text: "Refresh Stored Data",
        icon: "refresh",
        onClick: onRefreshStoredDataClick,
      },

      {
        text: "Logout",
        icon: "runner",
        onClick: onLogoutClick,
      },
    ];

    async function onLogoutClick() {
      const result = await auth.logOut(); // <-- await here
      if (result.isOk) {
        router.push({
          path: "/login-form",
          query: { redirect: route.path },
        });
      } else {
        console.error("Logout failed:", result.message);
      }
    }

    async function onRefreshStoredDataClick() {
      loadingVisible.value = true;

      try {
        await useCommonStore().forceReloadStoreAfterLogin();
      } catch (error) {
        console.error("Error reloading store:", error);
        loadingVisible.value = false;
      } finally {
        loadingVisible.value = false; // Ensure it hides after loading
      }
    }

    onMounted(async () => {
      if (appStore.getJustLogin()) {
        await onRefreshStoredDataClick();
        appStore.setJustLogin(false);
      }
    });

    // if (appStore.getJustLogin()) {
    //   console.log("Just Login, reload data");
    //   await onRefreshStoredDataClick(); // <-- Wait for data to reload first
    //   appStore.setJustLogin(false);
    // }

    // console.log("HEADERTOOLBAR", appStore.getJustLogin());
    return {
      name,
      email,
      userMenuItems,
      loadingVisible,
    };

    // function onProfileClick() {
    //   router.push({
    //     path: "/profile",
    //     query: { redirect: route.path },
    //   });
    // }
  },
  components: {
    DxButton,
    DxToolbar,
    DxItem,
    UserPanel,
    DxPopup,
  },
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

.header-component {
  flex: 0 0 auto;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 40px;

  .screen-x-small & {
    padding: 0 20px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .dx-item-content {
  padding: 0;
  margin: 0;
}

.dx-theme-generic {
  .dx-toolbar {
    padding: 10px 0;
  }

  .user-button > .dx-button-content {
    padding: 3px;
  }
}
</style>
